function normalizedText(value) {
  return String(value || "").trim().toLowerCase();
}

function positiveInt(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function isPostOpFollowUpNeed(need) {
  if (!need) return false;
  if (need.source_procedure_visit_id) return true;
  const name = normalizedText(need.procedure_name);
  const notes = normalizedText(need.notes);
  return /\bpost[-\s]?op\b/.test(name)
    || notes.includes("auto-suggested follow-up after");
}

export function isPostOpFollowUpBundle(bundle) {
  const needs = bundle?.needs || [];
  if (needs.length > 0) {
    return needs.every(isPostOpFollowUpNeed);
  }
  return /\bpost[-\s]?op\b/.test(normalizedText(bundle?.procedure_name));
}

export function followUpBundleKind(bundle) {
  return isPostOpFollowUpBundle(bundle) ? "post_op_follow_up" : "future_need";
}

export function followUpItemNoun(bundle) {
  return isPostOpFollowUpBundle(bundle) ? "post-op follow-up" : "future need";
}

export function followUpItemNounPlural(bundle, count = 2) {
  const noun = followUpItemNoun(bundle);
  if (count === 1) return noun;
  return noun === "post-op follow-up" ? "post-op follow-ups" : "future needs";
}

export function followUpRequestedDays(bundle) {
  const direct = positiveInt(bundle?.doctorRequestedDays);
  if (direct) return direct;
  const values = (bundle?.needs || [])
    .map((need) => positiveInt(need?.follow_up_after_days))
    .filter(Boolean);
  if (values.length === 0) return null;
  return Math.min(...values);
}

export function followUpBookingHeading(bundle) {
  const count = (bundle?.needs || []).length;
  const noun = followUpItemNoun(bundle);
  if (bundle?.isAll && count > 0) {
    return `Book all ${count} ${followUpItemNounPlural(bundle, count)}`;
  }
  return `Book ${noun}`;
}
